import { flowAsync } from '@gcc/nodash';
import { size, map } from 'lodash/fp';
import axios from 'axios';
import config from '../helpers/config';
import { sites } from '../helpers/globalVariables';
import { buyDesign } from '../api/designBuilder';

const mapWithKey = map.convert({ cap: false });

const enhanceYourCalm = (calmRate, func) => async () => {
  await func();
  await new Promise(r => setTimeout(r, calmRate));
};

class CartEstimateStrategy {
  constructor() {
    this.buyDesignApi = buyDesign;
  }

  performAddToCart = () => {};
}

class THDAddToCart extends CartEstimateStrategy {
  performAddToCart = designId => this.buyDesignApi(designId)
    .then((response) => {
      const batchedData = this.partitionCartRequest(response.data);

      const seqAtc = mapWithKey((request, idx, data) => {
        const atc = enhanceYourCalm(
          size(data) - 1 === idx ? 0 : config.thdCartCalmRate,
          () => this.invokeTHDCartApi(request),
        );

        return atc;
      })(batchedData);

      return flowAsync(...seqAtc)();
    });

  partitionCartRequest = (itemDetails) => {
    const batchedData = [];
    const batchSize = Math.max(+config.thdCartBatchSize, 5);

    if (itemDetails && itemDetails.length <= batchSize) {
      batchedData.push(itemDetails);
      return batchedData;
    }

    for (let ndx = 0; ndx < itemDetails.length; ndx += batchSize) {
      const partitionedRequest = [];
      partitionedRequest
        .push(...(itemDetails.slice(ndx, ndx + batchSize).reverse()));
      batchedData.push(partitionedRequest);
    }

    return batchedData;
  }

  invokeTHDCartApi = (payload) => {
    const thdCartQueryMessage = `mutation addToCart($cartRequest: CartInfoRequest!) {
      addToCart(cartRequest: $cartRequest) {
        cartId
        itemCount
        messages {
          type
          messageCategoryType
          correlationId
          correlationType
          longDesc
          shortDesc
        }
      }
    }`;

    const apiData = {
      query: thdCartQueryMessage,
      variables: {
        cartRequest: {
          filterItem: true,
          localization: {
            primaryStoreZipCode: 30339,
            primaryStoreId: 121,
          },
          cartAttr: {
            essentialAccessories: true,
          },
          items: {
            delivery: [...payload],
          },
        },
      },
    };
    return (axios(config.thdCartApiUrl, {
      method: 'post',
      data: apiData,
      withCredentials: true,
      headers: {
        'Accept': 'application/json; charset=utf-8',// eslint-disable-line
        'Content-Type': 'application/json',
        'X-Experience-Name': 'custom-measure-and-install',
      },
    }));
  };
}

class BlindsComAddToCart extends CartEstimateStrategy {
  performAddToCart = designId => this.buyDesignApi(designId)
    .then(response => axios.post(config.estimateBuilderAddtoCart, response.data));
}

class NotImplementedAddToCart {
  constructor() {
    this.buyDesignApi = Promise.reject(new Error('An add to cart strategy was not implemented for this site'));
  }

  performAddToCart = () => {
    /* eslint no-console: "off" */
    console.warn('An add to cart strategy was not implemented for this site');
    return this.buyDesignApi;
  }
}

export default class CartEstimateContext {
  strategies = {
    [sites.theHomeDepot]: new THDAddToCart(),
    [sites.blinds]: new BlindsComAddToCart(),
  }

  cartAnEstimate = (designId) => {
    const strategy = this.strategies[window.globalConfig.siteId] || new NotImplementedAddToCart();
    return strategy.performAddToCart(designId);
  }
}
